import TOdataQueryOptions from "@/core/types/TOdataQueryOptions";


const OdataQueryComposer = ( baseUrl: string, queryOptions?: (TOdataQueryOptions|null) ) : string => {
    if ( queryOptions === null ) return baseUrl;

    const queryList = [];
    let url = baseUrl;

    
    if (queryOptions?.filter && queryOptions?.filter?.length > 0) {
        queryList.push(`$filter=${queryOptions.filter.join(' ')}`);
    }
    if (queryOptions?.skip  && queryOptions?.skip >= 0) {
        queryList.push(`$skip=${queryOptions.skip}`);
    }
    if (queryOptions?.top && queryOptions?.top >= 0) {
        queryList.push(`$top=${queryOptions.top}`);
    }
    if (queryOptions?.orderBy && queryOptions?.orderBy?.length > 0) {
        queryList.push(`$orderby=${queryOptions.orderBy.join(',')}`);
    }
    if (queryOptions?.expands && queryOptions?.expands?.length > 0) {
        queryList.push(`$expand=${queryOptions.expands.join(',')}`);
    }
    if (queryOptions?.count === true) {
        queryList.push(`$count=true`);
    }
    if (queryOptions?.apply) {
        queryList.push(`$apply=${queryOptions.apply}`);
    }

    if (queryList.length > 0) {
        url = `${baseUrl}?${queryList.join('&')}`;
    }

    return url;
}

export default OdataQueryComposer;